import React, { useEffect, useState } from 'react';
import { DIGEST_DAYS, fetchNewsDays, type NewsDay as Day } from '../../utils/newsDigest';
import { NewsDay } from '../../components/portal/NewsDay';

/**
 * The daily round-up: UAE production industry, and GCC pitch opportunities.
 *
 * No explanatory subtitle under the title. A page called News on a studio's
 * own system does not need telling you what it is, and the line was pushing
 * the actual news down the screen — the one thing this page must not do.
 * What survives of it is a single quiet line at the very bottom, where a
 * reminder belongs.
 *
 * **Sentence case since 16 Oct 2026**, along with every other studio title.
 * The setup flow has always spoken in sentences — "Who is it for?", "Here's
 * what they'll get." — while the studio shouted NEWS, CLIENTS, CALL SHEETS,
 * so the two halves of the app read as two different products. Wrap-ups was
 * already the odd one out in the right direction; now they all match it.
 */
export function News() {
  const [days, setDays] = useState<Day[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    void fetchNewsDays().then(rows => {
      if (cancelled) return;
      setDays(rows);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  const [today, ...earlier] = days;
  return <div data-id="element-2401" data-mp="2q25idbc04rfk">
      <h1 className="font-display text-4xl leading-[0.95] tracking-tight sm:text-6xl" data-id="element-2402" data-mp="2u63j1qgz6aaq">News</h1>

      {loading && <p className="label mt-12 text-paper/35" data-id="element-2403" data-mp="2z4wxpm8007ch">Loading…</p>}

      {!loading && days.length === 0 && <p className="mt-12 max-w-[30ch] font-display text-2xl leading-tight text-paper/45" data-id="element-2404" data-mp="33w6mylpmx8nu">
          Nothing here yet. The round-up is written each morning — the first one lands tomorrow.
        </p>}

      {today && <div className="mt-12" data-id="element-2405" data-mp="3dv495hzl8q3o">
          <NewsDay day={today} lead data-id="element-2406" data-mp="3drzutrsesdza" />
        </div>}

      {earlier.length > 0 && <div className="mt-8 space-y-16" data-id="element-2407" data-mp="3hvxsrz5zziqr">
          {earlier.map(day => <NewsDay key={day.date} day={day} lead={false} data-id="element-2408" data-mp="1irpq5jkrxifx" />)}
        </div>}

      {!loading && days.length > 0 && <p className="label-sm mt-8 border-t border-ruleDark pt-8 text-paper/20" data-id="element-2409" data-mp="1dq0a1pip2ekz">
          Written each morning · {DIGEST_DAYS} days kept
        </p>}
    </div>;
}